var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCritterCatalogSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 250.0 250.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l250.0 0l0 250.0l-250.0 0l0 -250.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l250.0 0l0 250.0l-250.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m25.401575 0l141.41731 0l0 118.67716l-141.41731 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m127.99532 87.15437l-31.234375 0l4.4375 -20.921875q1.953125 -9.140625 1.421875 -11.390625q-0.53125 -2.265625 -3.9375 -2.265625q-3.859375 0 -5.484375 2.75q-1.609375 2.734375 -3.5625 11.859375l-11.859375 55.8125q-1.859375 8.765625 -1.390625 11.4375q0.46875 2.671875 4.109375 2.671875q3.484375 0 5.125 -2.671875q1.65625 -2.671875 3.75 -12.546875l3.203125 -15.0625l31.234375 0l-0.984375 4.671875q-3.96875 18.625 -8.265625 26.421875q-4.28125 7.796875 -14.546875 13.671875q-10.25 5.859375 -23.46875 5.859375q-13.71875 0 -21.578125 -4.96875q-7.84375 -4.984375 -8.875 -13.78125q-1.03125 -8.796875 2.71875 -26.453125l7.46875 -35.109375q2.765625 -12.984375 5.03125 -19.484375q2.28125 -6.5 7.96875 -12.5q5.6875 -6.015625 14.25 -9.46875q8.578125 -3.453125 18.734375 -3.453125q13.8125 0 21.65625 5.34375q7.8437576 5.34375 8.968758 13.328125q1.125 7.96875 -2.46875 24.828125l-2.4218826 11.421875z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m91.37795 58.94685l141.41733 0l0 118.677155l-141.41733 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m193.97171 146.10123l-31.234375 0l4.4375 -20.921875q1.953125 -9.140625 1.421875 -11.390625q-0.53125 -2.265625 -3.9375 -2.265625q-3.859375 0 -5.484375 2.75q-1.609375 2.734375 -3.5625 11.859375l-11.859375 55.8125q-1.859375 8.765625 -1.390625 11.4375q0.46875 2.671875 4.109375 2.671875q3.484375 0 5.125 -2.671875q1.65625 -2.671875 3.75 -12.546875l3.203125 -15.0625l31.234375 0l-0.984375 4.671875q-3.96875 18.625 -8.265625 26.421875q-4.28125 7.796875 -14.546875 13.671875q-10.25 5.859375 -23.46875 5.859375q-13.71875 0 -21.578133 -4.96875q-7.84375 -4.984375 -8.875 -13.78125q-1.03125 -8.796875 2.71875 -26.453125l7.46875 -35.109375q2.765625 -12.984375 5.03125 -19.484375q2.2812576 -6.5 7.9687576 -12.5q5.6875 -6.015625 14.25 -9.46875q8.578125 -3.453125 18.734375 -3.453125q13.8125 0 21.65625 5.34375q7.84375 5.34375 8.96875 13.328125q1.125 7.96875 -2.46875 24.828125l-2.421875 11.421875z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritterCatalogSmall);
export default __webpack_public_path__ + "static/media/critter-catalog-small.5be35570.svg";
export { ForwardRef as ReactComponent };